import { useEffect, useState } from "react";
import Sidebar from "components/Common/SideBar/SideBar";
import CoreRatioHeader from "components/Common/Header/Header";
import { useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Default from "components/Common/Default/Default";
import classes from "./CoreRatioLayout.module.css";
import CoreRatioManagement from "components/CoreRatio/CoreRatioManagement";

const CoreRatioLayout = () => {
  const location = useLocation();

  const [index, setIndex] = useState(0);

  useEffect(() => {
    console.log("Location: ", location.pathname.toLowerCase());
    const path = location.pathname.toLowerCase();
    if (path === "/coreratio") setIndex(() => 0);
    if (location.pathname === "/coreratio/goe") setIndex(() => 1);
  }, [location.pathname]);

  return (
    <Grid container spacing={2} className={classes.coreRatioBody}>
      <Grid item xs={0.75} className={classes.grid}>
        <Sidebar index={index} type="coreratio" />
      </Grid>
      <Grid item xs={11.25} className={classes.grid}>
        <CoreRatioHeader
          title="Core Ratio"
          logoURL="/coreratio"
          version="new"
        />
        <div className={classes.content}>
          {index === 0 && <Default />}
          {index === 1 && <CoreRatioManagement />}
        </div>
      </Grid>
    </Grid>
  );
};

export default CoreRatioLayout;
